import { CaracteristicaCodigoEquipoModel } from '@/store/catalogos/caracteristicaCodigoEquipo';
import { Util } from '@/utils/util';
import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CaracteristicaCodigoEquipoService } from '@services/catalogo/caracteristicaCodigoEquipo.service';
import { ValidatorsService } from '@services/util/validators.service';

@Component({
  selector: 'app-formulario-codigo-equipo-caracteristica-editar',
  templateUrl: './formulario-codigo-equipo-caracteristica-editar.component.html',
  styleUrls: ['./formulario-codigo-equipo-caracteristica-editar.component.scss']
})
export class FormularioCodigoEquipoCaracteristicaEditarComponent {
  title: string = "Modificar Característica de inspección";
  form: FormGroup;
  constructor(
    private catalogoService: CaracteristicaCodigoEquipoService,
    public dialogRef: MatDialogRef<any>,
    private validatorsService: ValidatorsService,
    private util: Util,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
console.log(data);
  }

  ngOnInit() {
    this.buildForm(this.data?.row);
  }

    private buildForm(data: CaracteristicaCodigoEquipoModel): void {
      this.form = new FormGroup({
        idCaracteristica: new FormControl(data?.idCaracteristica ?? null),
        caracteristicas: new FormControl(data?.carateristica ?? '', [Validators.required, Validators.maxLength(250)]),
        realizo: new FormControl(data.realiza ?? '', [Validators.required, Validators.maxLength(25)])
      });
    }
  
    isValidField(field: string): boolean {
      return this.form?.controls[field]?.invalid && this.form?.controls[field]?.touched;
    }
  
    getFieldError(field: string): string {
      return this.validatorsService.getFieldError(this.form, field);
    }

    
  enviar(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const caracteristica: CaracteristicaCodigoEquipoModel = this.formToModel();
    const request = this.catalogoService.update(caracteristica);


    request.subscribe(response => {
      if (response.success) {
        this.util.successMessage("Registro guardado con éxito!");
        this.dialogRef.close({ data: response });

      } else {
        const errorMsg = this.util.isEmpty(response.message)
          ? "Ocurrió un error al guardar el registro"
          : response.message;
        this.util.errorMessage(errorMsg);
      }
    });
  }

  private formToModel(): CaracteristicaCodigoEquipoModel {
    const formValues = this.form.getRawValue();

    return {
      idCaracteristica: formValues.idCaracteristica ?? '',
      carateristica: formValues.caracteristicas ?? '',
      realiza: formValues.realizo ?? '',
      equipo: {
        idCodigoEquipo: this.data.row.equipo.idCodigoEquipo ?? ''
      }
    };
  }
}
